const textFieldEquipStatusInput = {
  placeholder: 'Describe the reason...',
  helperText: '* Required field'
};

export default textFieldEquipStatusInput;
